import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20red%20and%20crimson%20abstract%20background%20with%20soft%20gradient%2C%20breaking%20news%20vibe%2C%20entertainment%20gossip%20atmosphere%2C%20bold%20dynamic%20texture%2C%20modern%20editorial%20design%2C%20cinematic%20lighting%20with%20warm%20tones%2C%20dramatic%20contrast%2C%20no%20text%20no%20people%2C%20abstract%20artistic%20geometric%20patterns&width=1600&height=900&seq=hero-bg-51chigua&orientation=landscape"
        alt="51吃瓜官网 - 全网最新吃瓜入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="51吃瓜官网 - 全网最新吃瓜入口"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-accent-200 text-sm font-medium">LIVE · 实时更新中</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4">
            {t('hero.title')}
            <span className="block text-accent-300">{t('hero.titleHighlight')}</span>
          </h1>

          <p className="text-white/70 text-sm md:text-base mb-2 font-medium tracking-widest uppercase">
            {t('hero.subtitle')}
          </p>

          <p className="text-white/60 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero.description')}
          </p>

          <div className="flex items-center justify-center gap-3 flex-wrap">
            <a
              href="#hot-topics"
              className="px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              {t('hero.cta')}
              <i className="ri-arrow-down-line ml-1.5"></i>
            </a>
            <a
              href="#latest-news"
              className="px-6 py-3 rounded-full bg-white/10 text-white font-medium text-sm whitespace-nowrap border border-white/20 hover:bg-white/20 transition-all duration-200 cursor-pointer"
            >
              {t('hero.secondaryCta')}
              <i className="ri-arrow-right-line ml-1.5"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}